/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */
export default {
    //类型
    type: 'icon',
    //类别
    class: 'elem',
    //组件名称
    name: '图标',
    //图标
    iconImg: '/image/viewElement/icon.png',
    //大屏图标
    bigIconImg: '/image/viewElement/icon.png',
    //是否在多维分析展示
    viewType: false,
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 0,
        //最小度量数量
        minDLLength: 0,
        //最大维度数量
        maxWDLength: 0,
        //最大度量数量
        maxDLLength: 0,
        //高
        dp_height: 150,
        //宽
        dp_wight: 220,
        //最小高
        dp_min_height: 30,
        //宽宽
        dp_min_wight: 30,
        //是否展示维度配置
        isWdConfig: false,
        //是否展示度量配置
        isDlConfig: false,
        //是否展示JSON配置
        isJSONConfig: false,
        //是否展示公共配置
        isComConfig: false,
        //是否展示边框
        isComBorder: false,
    },
    component: () => import('./component/iocnCom.vue'),
    // 子集展示的配置项
    chilCharts: [
        {
            name: '自定义',
            //多维分析图标
            ordImg: 'icon/icon.png',
            //大屏图标
            bigImg: 'icon/icon.png',
            //默认配置
            chartParam: {
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
        {
            name: '向左圆箭头',
            //多维分析图标
            ordImg: 'icon/left.png',
            //大屏图标
            bigImg: 'icon/left.png',
            //默认配置
            chartParam: {
                name:'ff_icon_xiangzuo2'
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
        {
            name: '向右圆箭头',
            //多维分析图标
            ordImg: 'icon/right.png',
            //大屏图标
            bigImg: 'icon/right.png',
            //默认配置
            chartParam: {
                name:'ff_icon_xiangyou2'
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
        {
            name: '增加',
            //多维分析图标
            ordImg: 'icon/plus.png',
            //大屏图标
            bigImg: 'icon/plus.png',
            //默认配置
            chartParam: {
                name:'ff_icon_jia'
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
        {
            name: '减少',
            //多维分析图标
            ordImg: 'icon/reduce.png',
            //大屏图标
            bigImg: 'icon/reduce.png',
            //默认配置
            chartParam: {
                name:'ff_icon_jian'
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
        {
            name: '上一页',
            //多维分析图标
            ordImg: 'icon/upper.png',
            //大屏图标
            bigImg: 'icon/upper.png',
            //默认配置
            chartParam: {
                name:'ff_icon_xiangyou1'
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
        {
            name: '下一页',
            //多维分析图标
            ordImg: 'icon/lower.png',
            //大屏图标
            bigImg: 'icon/lower.png',
            //默认配置
            chartParam: {
                name:'ff_icon_xiangzuo1'
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
    //度量参数
    dlHandle(option) {
        return {}
    },
    //配置参数
    params(option) {
        return {
            name:'ff_icon_yuanxingweixuanzhong',
            color: '#fff',
            hoverColor:'#fff',
            push: {
                type: true,
                url: '空',
            },
            transform:{
                type:'rotate',
                rotate:0,
                flipVertically:false,
                flipHorizontally:false,
            }
        }
    },
    //配置组件列表
    configModule:[
        {
            name: '图标配置',
            component: () => import('./config/icon_config')
        },
        {
            name: '跳转配置',
            component: () => import('../../comConfig/comPush/comPush.vue'),
        }],
    //接口
    JSONData: {
        //静态数组
        listDaVal: '',
        //接口参数
        params: {},
        //引用的组件
        jsonPonent: null,
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
    },
    //切换图表之前的回调
    renderBefore(chart, nowChart, dom) {

    },
    //渲染
    rendering(chart, nowChart, dom) {
    }
}
